import React from 'react';
import { Theme } from '@kvdbil/components/types/theme';
import { ThinCertifiedIcon, ThinWarningIcon } from '@kvdbil/components';
import { ConditionClassification } from '../interfaces/ProcessObject';

export const getConditionColors = (
  themeColors: Theme['colors'],
  condition: ConditionClassification
) => {
  switch (condition) {
    case 'REPAIR_OBJECT':
      return {
        backgroundColor: themeColors.tertiary.mainAlt,
        iconBackgroundColor: themeColors.tertiary.mainAlt,
        textColor: themeColors.text.light
      };
    case 'CERTIFIED':
    case 'CERTIFIED_PLUS':
      return {
        backgroundColor: themeColors.primary.lighter2,
        iconBackgroundColor: themeColors.primary.main,
        textColor: themeColors.text.dark
      };
    case 'TESTED':
      return {
        backgroundColor: themeColors.background.gray,
        textColor: themeColors.text.dark
      };
  }
};

export const getConditionIcon = (condition: ConditionClassification) => {
  switch (condition) {
    case 'REPAIR_OBJECT':
      return <ThinWarningIcon />;
    case 'CERTIFIED':
    case 'CERTIFIED_PLUS':
      return <ThinCertifiedIcon />;
  }
};
